import { useState, useEffect, useContext, useCallback } from 'react'
import { context } from 'components/form'
import { runValidations } from 'components/form/validations'

export default function useField({ validate, name, defaultValue }) {
  const form = useContext(context)(name)
  const [value, _setValue] = useState(defaultValue || '')

  const { dispatch, field } = form

  const changed = field && field.changed

  const error = field && field.error

  const getValue = useCallback(async () => value, [value])

  const runValidation = useCallback(
    (force) => {
      if (validate && (force || changed || error)) {
        return runValidations(validate)(value)
      }
    },
    [validate, value, changed, error]
  )

  useEffect(() => {
    if (name) {
      dispatch({
        type: 'add',
        field: {
          name,
          getValue,
          validate: runValidation,
          validations: validate,
        },
      })
    }
    return () => {
      if (name) {
        return dispatch({
          type: 'remove',
          name,
        })
      }
    }
  }, [dispatch, getValue, name, runValidation, validate])

  const setValue = useCallback(
    (newValue, changed = true) => {
      _setValue(newValue)
      if (name && changed) {
        dispatch({ type: 'change', name })
      }
    },
    [dispatch, name]
  )

  const revalidate = useCallback(() => {
    if (name) {
      setTimeout(() => {
        dispatch({ type: 'validate_field', name })
      }, 200)
    }
  }, [dispatch, name])

  const fieldId = form.formId && name && `${form.formId}-${name}`

  return {
    value,
    setValue,
    error,
    anyErrors: form.anyErrors,
    id: fieldId,
    formLoading: form.loading,
    revalidate,
  }
}
